import axiosInstance from '../../utils/axiosConfig';

export const fetchGoodsByLicensePlate = (licensePlate) => async (dispatch) => {
    try {
        const url = `${process.env.REACT_APP_BACKEND_URL_MS_POLICY}/good/filterGoodsByCaracteristique`;
        const response = await axiosInstance.post(url, [
            { key: "License_plate", value: licensePlate },
        ]);
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
            return response.data;
        } else {
            throw new Error("No goods found with the specified license plate.");
        }
    } catch (error) {
        console.error("Error fetching goods by license plate:", error);
        throw error;
    }
};

export async function getPolicyDetails(policyNumber) {
  try {
 
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_POLICY}/policy/${policyNumber}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching policy details: ${error.message}`);
  }
}


/**
 * Lists the policy usages (referential of the claim creation form).
 */
export async function getAllPolicyUsages() {
  try {
    const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_POLICY}/policyUsage/getAllPolicyUsage`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error(`Error fetching policy usages: ${error.message}`);
    return [];
  }
}

export async function getGoodsForPolicy(policyNumber) {
  try {
 
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_POLICY}/policy/getGoodsForPolicy/${policyNumber}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching Goods For policy: ${error.message}`);
  }
}

export async function getGoodDetails(goodUid) {
  try {
 
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_POLICY}/good/${goodUid}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching Goods : ${error.message}`);
  }
}

export async function getCoverageByCode(code) {
  try {
 
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_POLICY}/coverage/findCoverageByCode/${code}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching Coverage : ${error.message}`);
  }
}

export function getAllCoverage() {
  return async (dispatch) => {
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_POLICY}/coverage/getAllCoverage`);
          dispatch({
              type: 'GET_COVERAGE',
              payload: response.data,
          });
          return response.data
      } catch (error) {
          console.error("Error fetching agencies:", error);
          dispatch({
              type: 'GET_COVERAGE_ERROR',
          });
      }
  };
}
